import React from 'react'

function Credits() {
  return (
    <div className='text-red Credits is-appear'>Made by Guillaume • All rights reserved © 2023</div>
  )
}

export default Credits